import { SyncStatus } from '@/core/offline'
import { UseTranslationResponse } from 'react-i18next'

export function formatDate(timestamp: number) {
  return new Date(timestamp).toLocaleString()
}

export function getSyncStatusColor(syncStatus: SyncStatus) {
  if (syncStatus.hasConflicts) return 'error'
  if (syncStatus.isActive) return 'info'
  if (syncStatus.pendingCount > 0) return 'warning'
  return 'success'
}

export function getSyncStatusText(syncStatus: SyncStatus, t: UseTranslationResponse<'translation'>['t']) {
  if (syncStatus.hasConflicts) return t('sync.conflictsDetected')
  if (syncStatus.isActive) return t('sync.syncInProgress')
  if (syncStatus.pendingCount > 0) return t('sync.itemsPendingSync')
  return t('sync.allSynced')
}

export function getQueueItemStatusColor(status: string) {
  switch (status) {
    case 'completed':
      return 'success'
    case 'failed':
      return 'error'
    case 'in_progress':
      return 'info'
    case 'pending':
    default:
      return 'warning'
  }
}

export function getQueueItemEntityIcon(entityType: string) {
  switch (entityType) {
    case 'patient':
      return '👤'
    case 'consultation':
      return '🩺'
    case 'document':
      return '📄'
    default:
      return '📋'
  }
}

export function getQueueItemActionLabel(action: string, t: UseTranslationResponse<'translation'>['t']) {
  switch (action) {
    case 'create':
      return t('sync.create')
    case 'update':
      return t('sync.update')
    case 'delete':
      return t('sync.delete')
    default:
      return action
  }
}
